import { NaOrderPaymentProps } from '.';
import { FC } from 'react';
import EuOrderPayment from './EuIteroOrderPayment';
import NaOrderPayment from './NaIteroOrderPayment';
import { isEMEAStore } from 'utils';

const OrderPayment: FC<NaOrderPaymentProps> = ({
  mode,
  onSubmit,
  selectedCreditCard,
  setCreditCard,
  paymentType,
  tmSelectedScannerFundingSource,
  tmSelectedScannerSubFundingSource,
  selectedScannerSubFundingSource,
  setSelectedScannerSubFundingSource,
  financingCompany,
}) => {
  const isEMEA = isEMEAStore();
  return (
    <>
      {isEMEA ? (
        <EuOrderPayment
          mode={mode}
          onSubmit={onSubmit}
          selectedCreditCard={selectedCreditCard}
          setCreditCard={setCreditCard}
          paymentType={paymentType}
          tmSelectedScannerFundingSource={tmSelectedScannerFundingSource}
        />
      ) : (
        <NaOrderPayment
          mode={mode}
          onSubmit={onSubmit}
          selectedCreditCard={selectedCreditCard}
          setCreditCard={setCreditCard}
          paymentType={paymentType}
          tmSelectedScannerFundingSource={tmSelectedScannerFundingSource}
          tmSelectedScannerSubFundingSource={tmSelectedScannerSubFundingSource}
          selectedScannerSubFundingSource={selectedScannerSubFundingSource}
          setSelectedScannerSubFundingSource={
            setSelectedScannerSubFundingSource
          }
          financingCompany={financingCompany}
        />
      )}
    </>
  );
};

export default OrderPayment;
